import BaseService from './baseService';

export default class SnowflakeTablesService extends BaseService {
    constructor() {
        super('snowflake-tables');
    }

    /**
    * Gets a dashboard table by ID
    * @param {Number} tableId - Snowflake tables id
    */
    getTable = (tableId: number) => this.httpGetRequest(tableId);

    /**
    * Gets snowflake tables.
    * @param {Object} filters - Filters for snowflake tables
    * @param {Array<number>} filters.tableIds - Snowflake tables ids
    * @param {Array<string>} filters.tableNames - Snowflake tables names
    * @param {Array<string>} filters.tableTypes - Snowflake tables types
    * @param {Array<number>} filters.releaseGroupIds - Release Group Ids
    * @param {number} filters.pageNumber - Page number
    * @param {number} filters.pageSize - Page size
    * @param {string} filters.searchString - Search String
    * @returns Snowflake tables list
    */
    list = (filters: Partial<{
        tableIds: number[],
        tableNames: string[],
        tableTypes: string[],
        releaseGroupIds: number[],
        pageNumber: number,
        pageSize: number,
        searchString: string
    }> = {}) => {
        const queryString = this.generateQueryString({
            t: filters.tableIds,
            n: filters.tableNames,
            tt: filters.tableTypes,
            r: filters.releaseGroupIds,
            p: filters.pageNumber,
            s: filters.pageSize,
            ss: filters.searchString
        });
        return this.httpGetRequest(`list?${queryString}`);
    }

    /**
     * Retrieves the list of available result tables for the specified scenario.
     * @param {number} scenarioId - The unique identifier of the scenario for which to retrieve the result tables
     * @retrun tables for scenario
     */
    getAvailableTables = (scenarioId: number) => this.httpGetRequest(`available/${scenarioId}`);
}